<template>
  <b-modal v-model="innerModal" hide-header :hide-footer="hideFooter" no-close-on-backdrop no-close-on-esc>
    <div>{{ body }}</div>
    <slot></slot>

    <template v-slot:modal-footer="{ ok }">
      <stella-button variant="primary" @click.native="ok(); $emit('alerted')">
        {{ $t('common.ok') }}
      </stella-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'AlertModal',
  props: {
    modal: Boolean,
    body: String,
    hideFooter: Boolean
  },
  data() {
    return {
      innerModal: false
    }
  },
  watch: {
    modal: function(value) {
      this.innerModal = value
    },
    innerModal: function(value) {
      this.$emit('toggleModal', value)
    }
  }
}
</script>

<style scoped lang="scss">
</style>
